import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js'

const emptyForm = () => ({
  id: null,
  title: '',
  pic_url: '',
  pic_url_welcome: '',
  pic_url_small: '',
  description: '',
  article: '',
  url: '',
  local_article: true
})

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    editor: RichTextEditor
  },

  props: {
    activeTab: {
      type: String
    },
    welcomeData: {
      type: Object
    }
  },

  data() {
    return {
      messages: _.map(this.welcomeData.welcome_messages || [], (message) => _.clone(message)),
      paths: this.welcomeData.paths,
      selectedId: null,
      isCreating: false,
      form: emptyForm(),
      contentTab: 'local',
      picUploading: false,
      saving: false
    }
  },

  computed: {
    showFormHint() {
      return !this.isCreating && this.selectedId == null
    },
    editorKey() {
      return this.isCreating ? 'new' : String(this.selectedId || 'empty')
    }
  },

  template: `
    <settings-container :activeTab="activeTab">
      <template slot="content">
        <div class="welcome-settings">
          <div class="welcome-settings-columns">
            <div class="welcome-list-panel">
              <div class="panel-card welcome-messages-preview">
                <div class="panel-card-body welcome-message-list">
                  <div v-for="(message, index) in messages"
                       :key="message.id"
                       class="message-item-wrapper"
                       :class="{ selected: message.id === selectedId }"
                       @click="selectMessage(message)">
                    <div class="message-item">
                      <img :src="index === 0 ? message.pic_url_welcome : message.pic_url_small"
                           :class="index === 0 ? 'welcome-message-pic' : 'welcome-message-pic-small'"
                           alt="" />
                      <div class="message-title">{{ message.title }}</div>
                    </div>
                  </div>
                </div>
                <div class="panel-card-foot">
                  <button class="btn btn-success btn-block btn-xs"
                          type="button"
                          @click="startCreate"
                          :disabled="isCreating">添加</button>
                </div>
              </div>
            </div>

            <div class="welcome-editor-panel">
              <div class="panel-card">
                <div class="panel-card-body">
                  <p v-if="showFormHint" class="welcome-form-hint text-info">
                    点击图文消息进行编辑，或者点击「添加」创建
                  </p>
                  <div v-else class="welcome-form">
                    <div class="form-field">
                      <div class="form-field-head">
                        <div class="form-field-title required">标题</div>
                      </div>
                      <div class="form-field-input-container">
                        <div class="form-field-input">
                          <input v-model.trim="form.title"
                                 class="form-field-value"
                                 type="text"
                                 placeholder="请输入" />
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="form-field-head">
                        <div class="form-field-title required">封面</div>
                      </div>
                      <div class="form-field-input-container">
                        <label class="welcome-upload-label" :class="{ disabled: picUploading }">
                          <input type="file"
                                 accept="image/*"
                                 class="hidden-input"
                                 @change="uploadCover"
                                 :disabled="picUploading" />
                          <span class="btn btn-default btn-xs">{{ picUploading ? '封面正在上传...' : '选择图片' }}</span>
                        </label>
                        <div v-if="form.pic_url_welcome" class="welcome-pic-preview">
                          <img :src="form.pic_url_welcome" alt="封面预览" />
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="form-field-head">
                        <div class="form-field-title">描述</div>
                      </div>
                      <div class="form-field-input-container">
                        <textarea v-model.trim="form.description"
                                  class="form-field-value"
                                  rows="3"
                                  placeholder="当有且仅有一条图文消息时才会展示给用户"></textarea>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="welcome-content-tabs" role="tablist">
                        <span role="tab"
                              class="welcome-tab"
                              :class="{ active: contentTab === 'local' }"
                              tabindex="0"
                              @click="setContentTab('local')"
                              @keydown.enter.prevent="setContentTab('local')"
                              @keydown.space.prevent="setContentTab('local')">文章</span>
                        <span role="tab"
                              class="welcome-tab"
                              :class="{ active: contentTab === 'reflink' }"
                              tabindex="0"
                              @click="setContentTab('reflink')"
                              @keydown.enter.prevent="setContentTab('reflink')"
                              @keydown.space.prevent="setContentTab('reflink')">链接</span>
                      </div>
                      <div v-show="contentTab === 'local'" class="welcome-editor-field">
                        <editor :key="editorKey"
                                ref="editor"
                                :value="form.article"
                                placeholder="正文"
                                scrollingContainer="main>.main-content"
                                @valueChanged="onArticleChange" />
                      </div>
                      <div v-show="contentTab === 'reflink'" class="welcome-reflink-field">
                        <div class="form-field-input-container">
                          <div class="form-field-input">
                            <input v-model.trim="form.url"
                                   class="form-field-value"
                                   type="text"
                                   placeholder="请输入链接地址" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="welcome-form-actions">
                      <template v-if="isCreating">
                        <button type="button" class="btn btn-default btn-xs" @click="cancelForm">取消</button>
                        <button type="button"
                                class="btn btn-primary btn-xs"
                                :disabled="saving"
                                @click="submitCreate">{{ saving ? '添加中...' : '添加' }}</button>
                      </template>
                      <template v-else>
                        <button type="button" class="btn btn-default btn-xs" @click="confirmDestroy">删除</button>
                        <button type="button"
                                class="btn btn-primary btn-xs"
                                :disabled="saving"
                                @click="submitUpdate">{{ saving ? '更新中...' : '更新' }}</button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </settings-container>
  `,

  methods: {
    selectMessage(message) {
      this.isCreating = false
      this.selectedId = message.id
      this.form = _.clone(message)
      this.contentTab = message.local_article ? 'local' : 'reflink'
    },

    startCreate() {
      this.isCreating = true
      this.selectedId = null
      this.form = emptyForm()
      this.contentTab = 'local'
    },

    cancelForm() {
      this.isCreating = false
      this.selectedId = null
      this.form = emptyForm()
      this.contentTab = 'local'
    },

    setContentTab(tab) {
      this.contentTab = tab
      this.form.local_article = tab === 'local'
    },

    onArticleChange(value) {
      this.form.article = value
    },

    uploadCover(event) {
      const file = event.target.files[0]
      if (!file) return

      this.picUploading = true
      const image = new Skylark.Libs.Storage.Image(file)
      image.upload({
        success: (uploadedUrl) => {
          const url = Skylark.Libs.Storage.publicImageUrl(uploadedUrl)
          this.form.pic_url = url
          this.form.pic_url_welcome = Skylark.Libs.Storage.cropImage(url, 'welcome')
          this.form.pic_url_small = Skylark.Libs.Storage.cropImage(url, 'small_welcome')
        },
        error: () => {
          Skylark.Bridge.newAlertify('封面上传失败', { type: 'danger' })
        },
        complete: () => {
          this.picUploading = false
          event.target.value = ''
        }
      })
    },

    payload() {
      return {
        welcome_message: {
          title: this.form.title,
          pic_url: this.form.pic_url,
          description: this.form.description,
          article: this.form.article,
          url: this.form.url,
          local_article: this.form.local_article
        }
      }
    },

    submitCreate() {
      this.saving = true
      Skylark.Libs.Ajax.post(this.paths.welcome_messages, {
        data: this.payload(),
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          this.messages.push(data.welcome_message)
          Skylark.Bridge.newAlertify('添加成功', { type: 'success' })
          this.cancelForm()
        },
        error: (xhr) => {
          this.showErrors(xhr, '添加失败')
        },
        complete: () => {
          this.saving = false
        }
      })
    },

    submitUpdate() {
      this.saving = true
      Skylark.Libs.Ajax.patch(`${this.paths.welcome_messages}/${this.selectedId}`, {
        data: this.payload(),
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          const index = _.findIndex(this.messages, { id: data.welcome_message.id })
          if (index >= 0) {
            Vue.set(this.messages, index, data.welcome_message)
          }
          this.form = _.clone(data.welcome_message)
          Skylark.Bridge.newAlertify('更新成功', { type: 'success' })
        },
        error: (xhr) => {
          this.showErrors(xhr, '更新失败')
        },
        complete: () => {
          this.saving = false
        }
      })
    },

    confirmDestroy() {
      if (!window.confirm('确定删除？')) return
      this.destroyMessage()
    },

    destroyMessage() {
      Skylark.Libs.Ajax.delete(`${this.paths.welcome_messages}/${this.selectedId}`, {
        responseType: 'json',
        success: () => {
          this.messages = this.messages.filter((item) => item.id !== this.selectedId)
          Skylark.Bridge.newAlertify('删除成功', { type: 'success' })
          this.cancelForm()
        },
        error: () => {
          Skylark.Bridge.newAlertify('删除失败', { type: 'danger' })
        }
      })
    },

    showErrors(xhr, prefix) {
      const errors = xhr.responseJSON?.errors || ['未知错误']
      Skylark.Bridge.newAlertify(`${prefix}：${errors.join('，')}`, { type: 'danger' })
    }
  }
})
